<!-- Created by henian.xu on 2018/9/10. -->

<template>
    <page>
        <div
            class="body"
            slot="body"
        >
            <el-button
                type="primary"
                size="small"
                @click="()=>{submit()}"
            >
                提交
            </el-button>
            <DynamicForm
                ref="dynamicForm"
                :data="formData"
            />
        </div>
    </page>
</template>

<script>
export default {
    name: 'BaiduMapPage',
    data() {
        return {};
    },
    computed: {
        formData() {
            return {
                initDataJson: {},
                formDataJson: {
                    name: 'tzzyczzsq',
                    attrs: null,
                    uiProps: {
                        border: true,
                        showFeedback: true,
                        align: 'right',
                    },
                    fields: [
                        {
                            name: 'signature',
                            label: '签名',
                            type: 'signature',
                            properties: {
                                value: '',
                                defaultValue: '',
                                placeholder: '添加经历',
                                tips: '',
                                required: true,
                                validates: null,
                            },
                            uiProps: {
                                // direction: 'column',
                            },
                        },
                        {
                            name: 'studyHistory',
                            label: '学习经历',
                            type: 'studyHistory',
                            properties: {
                                value: '',
                                defaultValue: '',
                                placeholder: '添加经历',
                                tips: '',
                                required: true,
                                validates: null,
                            },
                            uiProps: {
                                direction: 'column',
                            },
                        },
                        {
                            name: 'workHistory',
                            label: '工作经历',
                            type: 'workHistory',
                            properties: {
                                value: '',
                                defaultValue: '',
                                placeholder: '添加经历',
                                tips: '',
                                required: true,
                                validates: null,
                            },
                            uiProps: {
                                direction: 'column',
                            },
                        },
                        {
                            name: 'fullName',
                            label: '姓名',
                            type: 'text',
                            properties: {
                                value: '',
                                defaultValue: '',
                                placeholder: '请输入',
                                tips: 'sfasdfasdfasdf',
                                required: true,
                                validates: null,
                            },
                        },
                        {
                            name: 'sex',
                            label: '性别',
                            type: 'select',
                            properties: {
                                value: '',
                                defaultValue: '',
                                placeholder: '请选择',
                                tips: '请选择性别tips',
                                required: true,
                                validates: null,
                                options: [{ id: '1', name: '男' }, { id: '2', name: '女' }],
                                extraOptions: [{ id: '', name: '请选择' }],
                            },
                        },
                        {
                            name: 'birthDate',
                            label: '出生年月',
                            type: 'date',
                            properties: {
                                value: '',
                                defaultValue: '',
                                placeholder: '请选择',
                                tips: '',
                                required: true,
                                validates: null,
                                dateFormat: 'YYYY-MM-DD',
                            },
                        },
                        {
                            name: 'education',
                            label: '学历',
                            type: 'select',
                            properties: {
                                value: '',
                                defaultValue: '',
                                placeholder: '请选择',
                                tips: '',
                                required: true,
                                validates: null,
                                options: '[DICTIONARY]:highestEducation',
                                enableOther: 999999,
                                extraOptions: [{ id: '', name: '请选择' }],
                                optionsProps: null,
                            },
                        },
                        {
                            name: 'regionId',
                            label: '地区',
                            type: 'region',
                            properties: {
                                value: '',
                                defaultValue: '',
                                placeholder: '请选择',
                                tips: '',
                                required: true,
                                validates: null,
                            },
                        },
                        {
                            name: 'address',
                            label: '详细地址',
                            type: 'textarea',
                            properties: {
                                value: '',
                                defaultValue: '',
                                placeholder: '请输入',
                                tips: '',
                                required: true,
                                validates: null,
                                minRows: 1,
                                maxRows: null,
                            },
                        },
                        {
                            name: 'companyName',
                            label: '工作单位',
                            type: 'text',
                            properties: {
                                value: '',
                                defaultValue: '',
                                placeholder: '请输入',
                                tips: '',
                                required: true,
                                validates: null,
                            },
                        },
                        {
                            name: 'politicalAffiliation',
                            label: '政治面貌',
                            type: 'select',
                            properties: {
                                value: '',
                                defaultValue: '',
                                placeholder: '请选择',
                                tips: '',
                                required: true,
                                validates: null,
                                options: '[DICTIONARY]:politicalAffiliation',
                                enableOther: 999999,
                                extraOptions: [{ id: '', name: '请选择' }],
                                optionsProps: null,
                            },
                        },
                        {
                            name: 'tel',
                            label: '联系电话',
                            type: 'text',
                            properties: {
                                value: '',
                                defaultValue: '',
                                placeholder: '请输入',
                                tips: '',
                                required: true,
                                validates: [
                                    {
                                        type: 'mobile',
                                        method: '',
                                        message: '手机号格式不正确',
                                    },
                                ],
                            },
                        },
                        {
                            name: 'healthStatus',
                            label: '健康状态',
                            type: 'select',
                            properties: {
                                value: '',
                                defaultValue: '',
                                placeholder: '请选择',
                                tips: '',
                                required: true,
                                validates: null,
                                options: '[DICTIONARY]:healthStatus',
                                enableOther: 999999,
                                extraOptions: [{ id: '', name: '请选择' }],
                                optionsProps: null,
                            },
                        },
                        {
                            name: 'idCardNo',
                            label: '身份证',
                            type: 'text',
                            properties: {
                                value: '',
                                defaultValue: '',
                                placeholder: '请输入',
                                tips: '',
                                required: true,
                                validates: [
                                    {
                                        type: 'iDCard',
                                        method: '',
                                        message: '身份证号格式不正确',
                                    },
                                ],
                            },
                        },
                        {
                            name: 'passport',
                            label: '护照',
                            type: 'text',
                            properties: {
                                value: '',
                                defaultValue: '',
                                placeholder: '请输入',
                                tips: '',
                                required: true,
                                validates: null,
                            },
                        },
                        {
                            name: 'photoOneInch',
                            label: '1寸照片', // 2.5cm * 3.5cm
                            type: 'file',
                            properties: {
                                value: [
                                    {
                                        address:
                                            'http://192.168.1.152:4333/upload/fileLibrary/2020/04/27/12bd7eba6ea849d299df68f8249a6435.png',
                                        name: '2020/04/27/12bd7eba6ea849d299df68f8249a6435.png',
                                    },
                                    {
                                        address:
                                            'http://192.168.1.152:4333/upload/fileLibrary/2020/04/27/38e0c62ca2f047308647b34aeac2dcb9.jpg',
                                        name: '2020/04/27/38e0c62ca2f047308647b34aeac2dcb9.jpg',
                                    },
                                ],
                                defaultValue: '',
                                placeholder: '',
                                tips: '最大文件大小为 2 mb',
                                required: true,
                                validates: null,

                                action: '/comm/rs/attachment/uploadFileLibrary',
                                accept: 'image/*',
                                maxFiles: 1,
                                uiProps: {
                                    columns: 3,
                                    itemHeight: '140%',
                                    fit: 'contain',
                                    cropper: true,
                                },
                            },
                            uiProps: {
                                direction: 'column',
                            },
                        },
                        {
                            name: 'photoTwoInch',
                            label: '2寸照片', // 3.5cm * 4.9cm
                            type: 'file',
                            properties: {
                                value: [
                                    {
                                        address:
                                            'http://192.168.1.152:4333/upload/fileLibrary/2020/04/27/12bd7eba6ea849d299df68f8249a6435.png',
                                        name: '2020/04/27/12bd7eba6ea849d299df68f8249a6435.png',
                                    },
                                ],
                                defaultValue: '',
                                placeholder: '',
                                tips: '最大文件大小为 2 mb',
                                required: true,
                                validates: null,

                                action: '/comm/rs/attachment/uploadFileLibrary',
                                accept: 'image/*',
                                maxFiles: 1,
                                uiProps: {
                                    columns: 2.5,
                                    itemHeight: '140%',
                                    fit: 'contain',
                                },
                            },
                            uiProps: {
                                direction: 'column',
                            },
                        },
                        {
                            name: 'photoThreeInch',
                            label: '3寸照片', // 5.5cm * 8.4cm
                            type: 'file',
                            properties: {
                                value: [
                                    {
                                        address:
                                            'http://192.168.1.152:4333/upload/fileLibrary/2020/04/27/12bd7eba6ea849d299df68f8249a6435.png',
                                        name: '2020/04/27/12bd7eba6ea849d299df68f8249a6435.png',
                                    },
                                ],
                                defaultValue: '',
                                placeholder: '',
                                tips: '最大文件大小为 2 mb',
                                required: true,
                                validates: null,

                                action: '/comm/rs/attachment/uploadFileLibrary',
                                accept: 'image/*',
                                maxFiles: 1,
                                uiProps: {
                                    columns: 2,
                                    itemHeight: '152%',
                                    fit: 'contain',
                                },
                            },
                            uiProps: {
                                direction: 'column',
                            },
                        },
                    ],
                },
            };
            // return this.detail.formData || {};
        },
    },
    methods: {
        async submit() {
            console.log('submit');
            const formModel = await this.$refs.dynamicForm.submit();
            console.log(formModel);
        },
    },
};
</script>

<style lang="scss">
</style>
